export default {
    PrimaryRecordBackground: require('../assets/PrimaryRecordBackground.png'),
    PrimaryRecordLogoDark: require('../assets/PrimaryRecordLogoDark.png'),
    BasicLogo: require('../assets/PrimaryLogo.png'),
    IconSVG: require('../assets/primary-record-icon-svg.svg'),
    UsageScreenshots: [
        require('../assets/usage-screenshots/1.png'),
        require('../assets/usage-screenshots/2.png'),
        require('../assets/usage-screenshots/3.png'),
        require('../assets/usage-screenshots/4.png'),
        require('../assets/usage-screenshots/5.png'),
        require('../assets/usage-screenshots/6.png'),
        require('../assets/usage-screenshots/7.png'),
    ],
    NurseApproved: require('../assets/nurse-approved.png'),
    Puzzle: require('../assets/app/puzzle.png'),
    OneUpLogo: require('../assets/app/one-up-logo.png'),
    PrimaryRecordLogoDarkV2: require('../assets/app/primary-record-logo-dark-v2.png'),
    DesktopSplash: require('../assets/app/desktopSplash.jpg'),
    MobileSplash: require('../assets/app/mobileSplash.png'),
    LargeHeaderLogo: require('../assets/app/large-header-logo.png'),
    SmallHeaderLogo: require('../assets/app/small-header-logo.png'),
    LargeIconLogo: require('../assets/app/large-icon-logo.png'),
    FDALogo: require('../assets/app/fda.png'),
    nvidiaInceptionProgramLogo: require('../assets/nvidia-inception-program.jpg'),
    downloadInAppStore: require('../assets/app/download-in-app-store.svg'),
    downloadInGooglePlay: require('../assets/app/download-in-google-play.png'),
};
